import { render } from "./UserModifier.vue?vue&type=template&id=2051799e"
import script from "./UserModifier.vue?vue&type=script&lang=js"
export * from "./UserModifier.vue?vue&type=script&lang=js"
script.render = render

export default script